import api from './api';

export const selectTransById = async (id) => {
  const response = await api.get(`trans/${id}`);
  return response.data;
};

export const updateTrans = async (id, data) => {
  const response = await api.put(`trans/${id}`, data);
  return response.data;
};
